var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm._isMobile()&&_vm._widthLessThan768()&&this.isAgent)?_c('div',[_c('p',[_vm._v("为了保证订货平台安全性")]),_c('p',[_vm._v("请您用电脑登录代办处订货平台")])]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }